/** @file Normalizes a decoded image to 8-bit straight alpha; pixels are taken as sRGB (no ICC). */
import type { RgbaImage } from '@pose2d/math/types';
import { invariant } from '@pose2d/std/invariant';
import { unpremultiply } from './unpremultiply';

/** Returns a straight-alpha copy for hashing and storage; embedded colour profiles are not applied. */
export function normalizeImage(image: RgbaImage): RgbaImage {
  const { width, height } = image;
  invariant(image.data.length === width * height * 4, `normalizeImage: data is not ${width}x${height} RGBA`);
  const copy: RgbaImage = { width, height, data: image.data.slice(), premultiplied: image.premultiplied };
  const straight = copy.premultiplied ? unpremultiply(copy) : copy;
  const data = straight.data;
  // Fully transparent pixels hash the same whatever rgb they carried.
  for (let i = 0; i < data.length; i += 4) if (data[i + 3] === 0) data.fill(0, i, i + 3);
  return straight;
}
